import type { Hanger } from "@greeter/core";
import Fuse from "fuse.js";

const hangerColors: Record<string, string> = {
  black: "Sort",
  white: "Hvid",
  red: "Rød",
  blue: "Blå",
  green: "Grøn",
  yellow: "Gul",
  orange: "Orange",
  purple: "Lilla",
  violet: "Violet",
  pink: "Lyserød",
  brown: "Brun",
  gray: "Grå",
  grey: "Grå",
  silver: "Sølv",
  gold: "Guld",
  beige: "Beige",
  navy: "Marineblå",
  turquoise: "Turkis",
};

export function hangerColorLabel(color: string) {
  return hangerColors[color.trim().toLowerCase()] ?? color;
}

export function createHangerSearch(hangers: Hanger[]) {
  return new Fuse(
    hangers.map((hanger) => ({
      ...hanger,
      translatedColor: hangerColorLabel(hanger.hangerColor),
    })),
    {
      keys: ["hangerId", "hangerArea", "hangerColor", "translatedColor"],
      threshold: 0.3,
      ignoreLocation: true,
    },
  );
}

export function mergeHangerSearchResults(
  hangers: Hanger[],
  serverResults: Hanger[],
  query: string,
  index = createHangerSearch(hangers),
): Hanger[] {
  const normalized = query.trim().toLocaleLowerCase("da");
  if (!normalized) return hangers;
  const exact = [...hangers, ...serverResults].filter(
    (h) => h.hangerId.toLocaleLowerCase("da") === normalized,
  );
  const local = index.search(normalized).map((result) => result.item);
  const latest = new Map([...hangers, ...serverResults].map((h) => [h.id, h]));
  const seen = new Set<string>();
  return [...exact, ...serverResults, ...local]
    .filter((h) => {
      if (seen.has(h.id)) return false;
      seen.add(h.id);
      return true;
    })
    .map((h) => latest.get(h.id) ?? h);
}
